import React from "react";

import AccountCircle from "@/shared/assets/icons/accountCircle.svg";
import ChevronUp from "@/shared/assets/icons/chevronUp.svg";
import Gift from "@/shared/assets/icons/gift.svg";
import Headset from "@/shared/assets/icons/headset.svg";
import HelpOutline from "@/shared/assets/icons/helpOutline2.svg";
import Logout from "@/shared/assets/icons/logout.svg";
import Menu from "@/shared/assets/icons/menu.svg";

export type NavbarIconName = "menu" | "close" | "contact" | "help" | "profile" | "logout" | "chevron" | "gift";

const icons: Partial<Record<NavbarIconName, React.FC<React.SVGAttributes<SVGElement>>>> = {
  menu: Menu,
  contact: Headset,
  gift: Gift,
  help: HelpOutline,
  profile: AccountCircle,
  logout: Logout,
  chevron: ChevronUp,
};

const NavbarIcon = ({ name, size = 22 }: { name: NavbarIconName; size?: number }) => {
  const Icon = icons[name];

  if (Icon) return <Icon width={size} height={size} aria-hidden />;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden>
      <path d="m6 6 12 12M18 6 6 18" />
    </svg>
  );
};

export default NavbarIcon;
